import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import useSuspenseQuery from 'commons/useSuspenseQuery';
import useIsBrowser from 'hooks/useIsBrowser';
import { GET_LOCATION_FROM_ZIPCODE } from 'mocks/queries';
import getCleanLocation from './getCleanLocation';
import getLocationErrorMessage from './getLocationErrorMessage';
const DEFAULT_VALUE = {
  location: undefined,
  errorMessage: undefined,
  isLoading: false,
  refetch: () => {}
};
const useUserLocationFromZipcode = zipcode => {
  const $ = _c(21);
  const isBrowser = useIsBrowser();
  let t0;
  if ($[0] !== zipcode) {
    t0 = {
      zipcode
    };
    $[0] = zipcode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = !zipcode;
  let t2;
  if ($[2] !== t0 || $[3] !== t1) {
    t2 = {
      variables: t0,
      skip: t1
    };
    $[2] = t0;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const {
    loading,
    data,
    error,
    refetch: refetchQuery
  } = useSuspenseQuery(GET_LOCATION_FROM_ZIPCODE, t2);
  let t3;
  if ($[5] !== refetchQuery) {
    t3 = async updatedZipCode => {
      const {
        data: updatedData,
        error: updatedError
      } = await refetchQuery({
        zipcode: updatedZipCode
      });
      const updatedLocationResponse = updatedData?.getLocationFromZip;
      const updatedLocation = getCleanLocation(updatedLocationResponse);
      const updatedResponseStatus = updatedLocationResponse?.status;
      const updatedErrorMessage = getLocationErrorMessage({
        error: updatedError,
        isLoading: false,
        responseStatus: updatedResponseStatus,
        zipcode: updatedZipCode
      });
      return {
        location: updatedLocation,
        errorMessage: updatedErrorMessage
      };
    };
    $[5] = refetchQuery;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const refetch = t3;
  if (!isBrowser) {
    let t4;
    if ($[7] !== refetch) {
      t4 = {
        ...DEFAULT_VALUE,
        refetch
      };
      $[7] = refetch;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    return t4;
  }
  const isLoading = loading && !data;
  const locationResponse = data?.getLocationFromZip;
  const responseStatus = locationResponse?.status;
  let t4;
  if ($[9] !== error || $[10] !== isLoading || $[11] !== responseStatus || $[12] !== zipcode) {
    t4 = getLocationErrorMessage({
      error,
      isLoading,
      responseStatus,
      zipcode
    });
    $[9] = error;
    $[10] = isLoading;
    $[11] = responseStatus;
    $[12] = zipcode;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  const errorMessage = t4;
  let t5;
  if ($[14] !== locationResponse) {
    t5 = getCleanLocation(locationResponse);
    $[14] = locationResponse;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const location = t5;
  let t6;
  if ($[16] !== errorMessage || $[17] !== isLoading || $[18] !== location || $[19] !== refetch) {
    t6 = {
      location,
      errorMessage,
      isLoading,
      refetch
    };
    $[16] = errorMessage;
    $[17] = isLoading;
    $[18] = location;
    $[19] = refetch;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  return t6;
};
export default useUserLocationFromZipcode;